import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _CustomHeader;
import { Quill } from 'react-quill';
var Block = Quill.import('blots/block');

/**
 * A custom block-level Blot for the header and body formats supported by the RichTextEditor.
 * Designed to extend and support Quill's built-in Header format values.
 *
 * To add to the editor, register this Blot with Quill using the register API.
 *
 * @extends Block
 */
var CustomHeader = /*#__PURE__*/function (_Block) {
  _inheritsLoose(CustomHeader, _Block);
  function CustomHeader() {
    return _Block.apply(this, arguments) || this;
  }
  /**
   * Creates a DOM node for the selected header format and appends the necessary classes and attributes for styling.
   * For format values 1-6 or h1-h6, a section heading element is created with the corresponding number.
   * For format values body1-3 and caption, a paragraph element is created.
   *
   * @param {string} value - The data-value of the selected header format from the dropdown control
   * @returns node - the corresponding DOM node for the selected header format
   */
  CustomHeader.create = function create(value) {
    if (!this.isSupportedValue(value)) {
      return _Block.create.call(this, 'p');
    }

    // if a number passed in then it will create a header element of that corresponding number
    var node = _Block.create.call(this, this.isBodyFormat(value) ? 'P' : value);

    // assigns the classes and data-value
    this.configureNodeAttributes(node, value);
    return node;
  }

  /**
   * Returns the format values represented by domNode if it is this Blot's type,
   * no check that domNode is this Blot's type is required
   *
   * @param {Node} domNode - The domNode representing the blot
   * @returns the format values represented by the domNode
   */;
  CustomHeader.formats = function formats(domNode) {
    var data = domNode.getAttribute('data-value');
    if (!this.isSupportedValue(data)) {
      return _Block.formats.call(this, domNode);
    }
    return data;
  }

  /**
   * Assigns the class and data-value attribute to the domNode for the corresponding header format
   *
   * @param {Node} node - the domNode to be formatted
   * @param {string} format - the format value to be represented by the domNode
   */;
  CustomHeader.configureNodeAttributes = function configureNodeAttributes(node, format) {
    // adds the class ql-header-h# or ql-header-{format}
    if (Number.isInteger(Number.parseInt(format))) {
      node.classList.add("ql-header-h" + format);
      node.setAttribute('data-value', "h" + format);
    } else {
      node.classList.add("ql-header-" + format);
      node.setAttribute('data-value', format);
    }
  }

  /**
   * Helper function to check if the format value is supported by the CustomHeader blot
   * @param {string} value - The format value
   * @returns True if the format value is supported by the CustomHeader blot
   */;
  CustomHeader.isSupportedValue = function isSupportedValue(value) {
    return value && this.dataValues.indexOf(value.toString().toLowerCase()) > -1;
  }

  /**
   * Helper function to check if the format value is a header style format
   * @param {string} value - The format value
   * @returns True if the format value is a header style format
   */;
  CustomHeader.isHeaderFormat = function isHeaderFormat(value) {
    return value && this.headerFormatValues.indexOf(value.toString().toLowerCase()) > -1;
  }

  /**
   * Helper function to check if the format value is a body style format
   * @param {string} value - The format value
   * @returns True if the format value is a body style format
   */;
  CustomHeader.isBodyFormat = function isBodyFormat(value) {
    return value && this.bodyFormatValues.indexOf(value.toString().toLowerCase()) > -1;
  };
  return CustomHeader;
}(Block);
_CustomHeader = CustomHeader;
CustomHeader.blotName = 'header';
CustomHeader.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P'];
CustomHeader.headerFormatValues = ['1', '2', '3', '4', '5', '6', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
CustomHeader.bodyFormatValues = ['body1', 'body2', 'body3', 'caption'];
CustomHeader.dataValues = _CustomHeader.headerFormatValues.concat(_CustomHeader.bodyFormatValues);
export default CustomHeader;